var DURATION = 320;

var collapsibleButtons = document.querySelectorAll('.collapsible__button');

collapsibleButtons.forEach(function (button) {
  button.addEventListener('click', function () {
    var isOpen = button.classList.contains('collapsible__button-active');

    collapsibleButtons.forEach(function (otherButton) {
      if (otherButton !== button && otherButton.classList.contains('collapsible__button-active')) {
        closeCollapsible(otherButton);
      }
    });

    if (isOpen) {
      closeCollapsible(button);
    } else {
      openCollapsible(button);
    }
  });
});

function openCollapsible(button) {
  var content = button.nextElementSibling;
  button.classList.add('collapsible__button-active');

  content.style.display = 'block';
  content.style.visibility = 'visible';
  content.style.overflow = 'hidden';
  content.style.maxHeight = '0px';
  content.style.opacity = '0';

  var targetHeight = content.scrollHeight;

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      content.style.transition = 'max-height ' + DURATION + 'ms ease, opacity ' + DURATION + 'ms ease';
      content.style.maxHeight = targetHeight + 'px';
      content.style.opacity = '1';
    });
  });

  setTimeout(function () {
    content.style.transition = '';
    content.style.maxHeight = '';
    content.style.overflow = '';
  }, DURATION);
}

function closeCollapsible(button) {
  var content = button.nextElementSibling;
  button.classList.remove('collapsible__button-active');

  var startHeight = content.scrollHeight;
  content.style.overflow = 'hidden';
  content.style.maxHeight = startHeight + 'px';
  content.style.opacity = '1';

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      content.style.transition = 'max-height ' + DURATION + 'ms ease, opacity ' + DURATION + 'ms ease';
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
    });
  });

  setTimeout(function () {
    content.style.display = 'none';
    content.style.visibility = 'hidden';
    content.style.transition = '';
    content.style.maxHeight = '';
    content.style.overflow = '';
  }, DURATION);
}
